// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__sRYS4","tab":"styles_tab__3VyZ4","active":"styles_active__1KnTN"};